var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _g3, _path20, _path21, _path22, _g4, _path23, _path24, _path25, _g5, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMortgageCalculatorPbh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 207,
    viewBox: "0 0 300 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_979_4746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 207
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 0H0V207H300V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_979_4746)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "#E6E6E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 263C212.184 263 263 212.184 263 149.5C263 86.8157 212.184 36 149.5 36C86.8157 36 36 86.8157 36 149.5C36 212.184 86.8157 263 149.5 263Z",
    fill: "#C9C9CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236 148H66V207H236V148Z",
    fill: "#00430A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201 185V171C201 169.895 201.895 169 203 169H217C218.105 169 219 169.895 219 171V185C219 186.105 218.105 187 217 187H203C201.895 187 201 186.105 201 185Z",
    fill: "#19A036"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83 185V171C83 169.895 83.8954 169 85 169H99C100.105 169 101 169.895 101 171V185C101 186.105 100.105 187 99 187H85C83.8954 187 83 186.105 83 185Z",
    fill: "#19A036"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_4746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.5 148H50L69.5 103H230.5L250.5 148Z",
    fill: "#006A19"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108 160.5L150 125.5L192.5 160.5",
    stroke: "#19A036",
    strokeWidth: 12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118 158.063L151 131L184 158.063V207H118V158.063Z",
    fill: "#7BDD82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151 190C159.837 190 167 182.837 167 174C167 165.163 159.837 158 151 158C142.163 158 135 165.163 135 174C135 182.837 142.163 190 151 190Z",
    fill: "#002C04"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167 175H135V207H167V175Z",
    fill: "#002C04"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123 98H96V103H123V98Z",
    fill: "#006A19"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128 80H91V98H128V80Z",
    fill: "#19A036"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 72.0001C183.5 45.2143 205.214 23.5002 232 23.5002C258.786 23.5002 280.5 45.2143 280.5 72.0001C280.5 98.7859 258.786 120.5 232 120.5C205.214 120.5 183.5 98.7859 183.5 72.0001Z",
    fill: "#5AA3EE",
    stroke: "#FBFBFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C224.573 24 217.248 25.7233 210.6 29.0344C203.952 32.3454 198.164 37.1538 193.689 43.0814C189.215 49.0089 186.177 55.8938 184.815 63.1945C183.452 70.4951 183.803 78.0123 185.838 85.1547L232 72V24Z",
    fill: "#1F5D97"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_979_4746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 22,
    width: 52,
    height: 65
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M234 22H182V87H234V22Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C224.573 24 217.248 25.7233 210.6 29.0344C203.952 32.3454 198.164 37.1538 193.689 43.0814C189.215 49.0089 186.177 55.8938 184.815 63.1945C183.452 70.4951 183.803 78.0123 185.838 85.1547L232 72V24Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_979_4746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 24C224.573 24 217.248 25.7233 210.6 29.0344C203.952 32.3454 198.164 37.1538 193.689 43.0814C189.215 49.0089 186.177 55.8938 184.815 63.1945C183.452 70.4951 183.803 78.0123 185.838 85.1547L232 72V24Z",
    stroke: "#FBFBFB",
    strokeWidth: 2.86643
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C223.659 24 215.462 26.1736 208.217 30.3064C200.972 34.4392 194.929 40.3887 190.683 47.5684L232 72V24Z",
    fill: "#FB9F60"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_979_4746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 22,
    width: 46,
    height: 53
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M234 22H188V75H234V22Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C223.659 24 215.462 26.1736 208.217 30.3064C200.972 34.4392 194.929 40.3887 190.683 47.5684L232 72V24Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_979_4746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 24C223.659 24 215.462 26.1736 208.217 30.3064C200.972 34.4392 194.929 40.3887 190.683 47.5684L232 72V24Z",
    stroke: "#FBFBFB",
    strokeWidth: 2.86643
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C238.774 24 245.471 25.4338 251.651 28.207C257.831 30.9802 263.354 35.03 267.857 40.0903C272.361 45.1506 275.742 51.1067 277.778 57.5671C279.815 64.0275 280.462 70.8458 279.675 77.5738C278.888 84.3018 276.687 90.7872 273.215 96.6035C269.743 102.42 265.079 107.435 259.53 111.321C253.981 115.206 247.672 117.872 241.019 119.145C234.366 120.418 227.519 120.268 220.928 118.705L232 72V24Z",
    fill: "#EEFF41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_979_4746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: 22,
    width: 63,
    height: 100
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M282 22H219V122H282V22Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C238.774 24 245.471 25.4338 251.651 28.207C257.831 30.9802 263.354 35.03 267.857 40.0903C272.361 45.1506 275.742 51.1067 277.778 57.5671C279.815 64.0275 280.462 70.8458 279.675 77.5738C278.888 84.3018 276.687 90.7872 273.215 96.6035C269.743 102.42 265.079 107.435 259.53 111.321C253.981 115.206 247.672 117.872 241.019 119.145C234.366 120.418 227.519 120.268 220.928 118.705L232 72V24Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_979_4746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 24C238.774 24 245.471 25.4338 251.651 28.207C257.831 30.9802 263.354 35.03 267.857 40.0903C272.361 45.1506 275.742 51.1067 277.778 57.5671C279.815 64.0275 280.462 70.8458 279.675 77.5738C278.888 84.3018 276.687 90.7872 273.215 96.6035C269.743 102.42 265.079 107.435 259.53 111.321C253.981 115.206 247.672 117.872 241.019 119.145C234.366 120.418 227.519 120.268 220.928 118.705L232 72V24Z",
    stroke: "#FBFBFB",
    strokeWidth: 2.86643
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C225.845 24 219.747 25.184 214.038 27.4874L232 72V24Z",
    fill: "#9BCFE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_979_4746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 22,
    width: 22,
    height: 51
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234 22H212V73H234V22Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M232 24C225.845 24 219.747 25.184 214.038 27.4874L232 72V24Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_979_4746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 24C225.845 24 219.747 25.184 214.038 27.4874L232 72V24Z",
    stroke: "#FBFBFB",
    strokeWidth: 2.86643
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.12 72.0002C197.12 52.5598 212.88 36.8002 232.32 36.8002C251.76 36.8002 267.52 52.5598 267.52 72.0002C267.52 91.4406 251.76 107.2 232.32 107.2C212.88 107.2 197.12 91.4406 197.12 72.0002Z",
    fill: "#FBFBFB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M215.11 74.6604L212.249 82.3338H211.094L213.955 74.6604H215.11ZM225.396 76.4134C226.047 76.4134 226.536 76.5813 226.865 76.9172C227.198 77.2532 227.364 77.792 227.364 78.5338V82.3338H226.131V78.7543C226.131 78.3134 226.045 77.981 225.873 77.757C225.702 77.5331 225.441 77.4211 225.091 77.4211C224.601 77.4211 224.248 77.5786 224.031 77.8935C223.818 78.2049 223.711 78.658 223.711 79.2529V82.3338H222.478V78.7543C222.478 78.4603 222.439 78.2154 222.362 78.0195C222.289 77.82 222.175 77.6713 222.021 77.5733C221.867 77.4718 221.673 77.4211 221.438 77.4211C221.099 77.4211 220.828 77.4981 220.625 77.6521C220.425 77.806 220.282 78.0334 220.194 78.3344C220.107 78.6318 220.063 78.9974 220.063 79.4313V82.3338H218.83V76.5236H219.79L219.963 77.3056H220.032C220.151 77.1027 220.298 76.9365 220.473 76.807C220.651 76.6741 220.849 76.5761 221.066 76.5131C221.283 76.4466 221.508 76.4134 221.743 76.4134C222.177 76.4134 222.542 76.4904 222.84 76.6443C223.137 76.7948 223.359 77.0257 223.506 77.3371H223.601C223.783 77.0222 224.036 76.7895 224.362 76.6391C224.687 76.4886 225.032 76.4134 225.396 76.4134ZM234.208 79.4156C234.208 79.8984 234.145 80.3271 234.019 80.7015C233.893 81.0759 233.709 81.3925 233.468 81.6515C233.226 81.9069 232.936 82.1028 232.596 82.2393C232.257 82.3723 231.874 82.4388 231.447 82.4388C231.048 82.4388 230.682 82.3723 230.35 82.2393C230.017 82.1028 229.729 81.9069 229.484 81.6515C229.242 81.3925 229.055 81.0759 228.922 80.7015C228.789 80.3271 228.723 79.8984 228.723 79.4156C228.723 78.7752 228.833 78.2329 229.053 77.7885C229.277 77.3406 229.596 76.9995 230.009 76.765C230.422 76.5306 230.913 76.4134 231.484 76.4134C232.019 76.4134 232.491 76.5306 232.901 76.765C233.31 76.9995 233.63 77.3406 233.861 77.7885C234.092 78.2364 234.208 78.7787 234.208 79.4156ZM229.993 79.4156C229.993 79.839 230.044 80.2011 230.145 80.502C230.25 80.8029 230.411 81.0339 230.628 81.1948C230.845 81.3523 231.125 81.431 231.468 81.431C231.811 81.431 232.091 81.3523 232.308 81.1948C232.525 81.0339 232.684 80.8029 232.785 80.502C232.887 80.2011 232.937 79.839 232.937 79.4156C232.937 78.9922 232.887 78.6335 232.785 78.3396C232.684 78.0422 232.525 77.8165 232.308 77.6625C232.091 77.5051 231.809 77.4264 231.463 77.4264C230.952 77.4264 230.579 77.5978 230.345 77.9407C230.11 78.2836 229.993 78.7752 229.993 79.4156ZM238.632 76.4134C239.286 76.4134 239.795 76.5831 240.159 76.9225C240.526 77.2584 240.71 77.799 240.71 78.5443V82.3338H239.477V78.7752C239.477 78.3239 239.384 77.9862 239.198 77.7623C239.013 77.5348 238.726 77.4211 238.338 77.4211C237.774 77.4211 237.382 77.5943 237.162 77.9407C236.945 78.2871 236.837 78.7892 236.837 79.4471V82.3338H235.603V76.5236H236.564L236.737 77.3109H236.805C236.931 77.1079 237.087 76.9417 237.272 76.8123C237.461 76.6793 237.671 76.5796 237.902 76.5131C238.137 76.4466 238.38 76.4134 238.632 76.4134ZM244.578 81.4415C244.739 81.4415 244.898 81.4275 245.055 81.3995C245.213 81.368 245.356 81.3313 245.486 81.2893V82.2236C245.349 82.283 245.173 82.3338 244.956 82.3758C244.739 82.4178 244.513 82.4388 244.279 82.4388C243.95 82.4388 243.654 82.3845 243.392 82.276C243.129 82.1641 242.921 81.9734 242.767 81.704C242.613 81.4345 242.536 81.0619 242.536 80.586V77.4631H241.744V76.912L242.594 76.4764L242.998 75.2325H243.775V76.5236H245.439V77.4631H243.775V80.5703C243.775 80.8642 243.848 81.0829 243.995 81.2263C244.142 81.3698 244.336 81.4415 244.578 81.4415ZM247.879 74.167V76.2192C247.879 76.4326 247.872 76.6408 247.858 76.8438C247.847 77.0467 247.835 77.2042 247.821 77.3161H247.889C248.012 77.1132 248.162 76.947 248.341 76.8175C248.519 76.6846 248.718 76.5848 248.939 76.5184C249.163 76.4519 249.401 76.4186 249.653 76.4186C250.097 76.4186 250.475 76.4939 250.786 76.6443C251.098 76.7913 251.336 77.0205 251.5 77.3319C251.668 77.6433 251.752 78.0474 251.752 78.5443V82.3338H250.519V78.7752C250.519 78.3239 250.426 77.9862 250.24 77.7623C250.055 77.5348 249.768 77.4211 249.38 77.4211C249.005 77.4211 248.708 77.4998 248.487 77.6573C248.271 77.8113 248.115 78.0404 248.02 78.3449C247.926 78.6458 247.879 79.0132 247.879 79.4471V82.3338H246.645V74.167H247.879Z",
    fill: "#3A383F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M217.931 68.3799C217.401 68.3299 216.901 68.2499 216.431 68.1399C215.971 68.0299 215.586 67.8899 215.276 67.7199V65.3199C215.816 65.5999 216.376 65.8099 216.956 65.9499C217.546 66.0899 218.106 66.1599 218.636 66.1599C219.116 66.1599 219.466 66.0899 219.686 65.9499C219.916 65.7999 220.031 65.5849 220.031 65.3049C220.031 65.0849 219.971 64.9049 219.851 64.7649C219.731 64.6249 219.546 64.4949 219.296 64.3749C219.056 64.2449 218.661 64.0649 218.111 63.8349C217.141 63.4249 216.436 62.9649 215.996 62.4549C215.556 61.9449 215.336 61.3199 215.336 60.5799C215.336 59.8599 215.566 59.2449 216.026 58.7349C216.496 58.2149 217.131 57.8549 217.931 57.6549V56.1699H220.346V57.5349C221.086 57.6149 221.791 57.8099 222.461 58.1199V60.4599C221.581 59.9999 220.696 59.7699 219.806 59.7699C219.356 59.7699 218.996 59.8449 218.726 59.9949C218.456 60.1449 218.321 60.3649 218.321 60.6549C218.321 60.8549 218.386 61.0249 218.516 61.1649C218.656 61.3049 218.846 61.4349 219.086 61.5549C219.336 61.6749 219.731 61.8399 220.271 62.0499C220.981 62.3399 221.531 62.6299 221.921 62.9199C222.321 63.1999 222.611 63.5299 222.791 63.9099C222.971 64.2899 223.061 64.7649 223.061 65.3349C223.061 66.1149 222.836 66.7599 222.386 67.2699C221.936 67.7699 221.256 68.1099 220.346 68.2899V69.7449H217.931V68.3799ZM226.739 62.2599C226.739 61.9399 226.844 61.6749 227.054 61.4649C227.264 61.2549 227.529 61.1499 227.849 61.1499H236.909C237.229 61.1499 237.494 61.2549 237.704 61.4649C237.914 61.6749 238.019 61.9399 238.019 62.2599V64.5399C238.019 64.8599 237.914 65.1249 237.704 65.3349C237.494 65.5449 237.229 65.6499 236.909 65.6499H227.849C227.529 65.6499 227.264 65.5449 227.054 65.3349C226.844 65.1249 226.739 64.8599 226.739 64.5399V62.2599ZM235.098 62.2749C235.098 61.9549 235.203 61.6899 235.413 61.4799C235.623 61.2699 235.888 61.1649 236.208 61.1649H240.978C241.298 61.1649 241.563 61.2699 241.773 61.4799C241.983 61.6899 242.088 61.9549 242.088 62.2749V64.5399C242.088 64.8599 241.983 65.1249 241.773 65.3349C241.563 65.5449 241.298 65.6499 240.978 65.6499H236.208C235.888 65.6499 235.623 65.5449 235.413 65.3349C235.203 65.1249 235.098 64.8599 235.098 64.5399V62.2749ZM239.165 62.2599C239.165 61.9399 239.27 61.6749 239.48 61.4649C239.69 61.2549 239.955 61.1499 240.275 61.1499H249.335C249.655 61.1499 249.92 61.2549 250.13 61.4649C250.34 61.6749 250.445 61.9399 250.445 62.2599V64.5399C250.445 64.8599 250.34 65.1249 250.13 65.3349C249.92 65.5449 249.655 65.6499 249.335 65.6499H240.275C239.955 65.6499 239.69 65.5449 239.48 65.3349C239.27 65.1249 239.165 64.8599 239.165 64.5399V62.2599Z",
    fill: "#3A383F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_4746",
    x: 46,
    y: 103,
    width: 208.5,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_4746"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_4746",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgageCalculatorPbh);
export default __webpack_public_path__ + "static/media/mortgage-calculator-pbh.a3f0bcd08bcd7a535c07f4b0399598c3.svg";
export { ForwardRef as ReactComponent };